module.exports = __webpack_public_path__ + "fonts/KaTeX_Fraktur-Bold.4c761b3.ttf";